import React, { forwardRef, useCallback, useImperativeHandle, useState } from 'react';
import { Button, DigitInputs, Link, QRCode, ToastNotification } from '@philips-internal/oswald-ui-components';
import { ToastLevel } from '@philips-internal/oswald-ui-constants';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { isContentfulString } from '@philips-internal/oswald-ui-utils';
import './multi-factor-authentication-activation.css';
function InternalMultiFactorActivation(props, ref) {
    const { activationExpression = 'tws.mfa-activation.activation', codeSize = 6, continueExpression = 'tws.mfa.continue', inputCodeExpression = 'tws.mfa.default-input-code', } = props;
    const [code, setCode] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    useImperativeHandle(ref, () => ({
        setErrorMessage,
    }));
    const onContinueClick = useCallback(() => {
        props.onSendCode(code);
    }, [code]);
    const onDigitsReady = useCallback((event) => {
        setCode(event.value);
    }, []);
    const onLinkClick = useCallback(() => {
        void window.navigator.clipboard.writeText(props.secret);
    }, [props.secret]);
    return (React.createElement("div", { className: "c-multi-factor-authentication-activation" },
        isContentfulString(errorMessage) ? (React.createElement(ToastNotification, { className: "c-multi-factor-authentication__notification", dismissible: false, inline: true, level: ToastLevel.ERROR, message: MessageService.translate(errorMessage), showIcon: true })) : null,
        React.createElement("div", { className: "c-multi-factor-authentication-activation__scanning" },
            React.createElement("div", null,
                React.createElement("span", { className: "c-multi-factor-authentication-activation__text" }, MessageService.translate(activationExpression)),
                React.createElement(Link, { onClick: onLinkClick, value: "tws.mfa-activation.clipboard" })),
            React.createElement("div", { className: "c-multi-factor-authentication-activation__qrcode" },
                React.createElement(QRCode, { value: props.link }))),
        React.createElement("div", { className: "c-multi-factor-authentication-activation__confirm" },
            React.createElement("div", { className: "c-multi-factor-authentication-activation__text" },
                React.createElement("span", { className: "c-multi-factor-authentication-activation__text" }, MessageService.translate(inputCodeExpression, { codeSize }))),
            React.createElement("div", { className: "c-multi-factor-authentication-activation__input" },
                React.createElement(DigitInputs, { digits: codeSize, onReady: onDigitsReady }),
                React.createElement(Button, { onClick: onContinueClick, value: continueExpression })))));
}
const MultiFactorAuthenticationActivation = forwardRef(InternalMultiFactorActivation);
export { MultiFactorAuthenticationActivation, };
//# sourceMappingURL=multi-factor-authentication-activation.js.map